module.exports = __webpack_public_path__ + "static/img/electrical-components_256.9a506a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/electrical-components_256.png
// module id = 00Uf
// module chunks = 0